import React from "react";

const ElectricFittings = ({ data, quotationType }) => {
  let serial = 1;
  return (
    <div>
      <style>{`
        h3 {
          margin-top: 14px;
          margin-bottom: 2px;
        }
        th, td, tr {
          margin: -2px;
          border-collapse: collapse;
          paddingTop: -2px;
          border: 1px solid #181818;
          text-align: left;
          padding: 0px 3px;
          font-size: 13px;
        }
        table {
          border-collapse: collapse
        }  
      `}</style>
      <h3 className="table-heading">Electric Fittings:</h3>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "30%" }}>Item</th>
            <th>Description / Specification</th>
          </tr>
        </thead>

        <tbody>
          {data?.quotationType !== "fanpad" &&
            data?.quotationType !== "nvph" &&
            data?.quotationType !== "nethouse" &&
            data?.quotationType !== "soilbasedfanpad" &&
            data?.quotationType !== "soilbasednvph" &&
            data?.quotationType !== "soilbasednethouse" && (
              <>
                <tr>
                  <td>{serial++}.</td>
                  <td>Water pumps</td>
                  <td>
                    Multiple water pumps of different capacities to lift water
                    from reservoir. Actual capacity to be determined during site
                    inspection.
                  </td>
                </tr>
              </>
            )}

          {quotationType !== "fanpad" &&
            quotationType !== "soilbasedfanpad" && (
              <tr>
                <td>{serial++}.</td>
                <td>Fogger pump</td>
                <td>
                  Fogger pump of 1.5/2hp (as per the area of land) to build
                  adequate pressure on foggers to operate smoothly.
                </td>
              </tr>
            )}
          {quotationType !== "fanpad" &&
            quotationType !== "soilbasedfanpad" && (
              <tr>
                <td>{serial++}.</td>
                <td>Digital / Analogue timers</td>
                <td>
                  Digital / Analogue timer to maintain day-to-day operations at
                  set intervals.
                </td>
              </tr>
            )}

          {quotationType !== "fanpad" &&
            quotationType !== "soilbasedfanpad" && (
              <tr>
                <td>{serial++}.</td>
                <td>Connection to DG / Solar panel</td>
                <td>
                  Entire system connection to diesel generator / flex generator
                  or solar panel (if made available by you).
                </td>
              </tr>
            )}
          {/* <% if record.quotation_type_fan_pad? %> */}
          {data?.quotationType !== "fanpad" &&
            data?.quotationType !== "nvph" &&
            data?.quotationType !== "nethouse" &&
            data?.quotationType !== "soilbasedfanpad" &&
            data?.quotationType !== "soilbasednvph" &&
            data?.quotationType !== "soilbasednethouse" && (
              <tr>
                <td>{serial++}.</td>
                <td>Submersible pump</td>
                <td>3 Phase submersible pump connection to control panel.</td>
              </tr>
            )}
          {data?.quotationType?.includes("fanpad") && (
            <>
              <tr>
                <td>{serial++}.</td>
                <td>
                  Temp &amp; Humidity sensor to CP (Applicable to Fan-Pad)
                </td>
                <td>
                  Connect multiple temp and humidity sensors to the control
                  panel.
                </td>
              </tr>
              <tr>
                <td>{serial++}.</td>
                <td>Exhaust fan (Applicable to Fan-Pad)</td>
                <td>Exhaust fan connection to control panel.</td>
              </tr>
              <tr>
                <td>{serial++}.</td>
                <td>Air circulation fan (Applicable to Fan-Pad)</td>
                <td>
                  Connect air circulation fan to timer as well as sensor based
                  module at control panel.
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>

      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
    </div>
  );
};

export default ElectricFittings;
